<!-- eslint-disable vue/no-v-html -->
<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-left bg-no-repeat after:absolute after:left-0 after:top-0 after:block after:h-full after:w-full after:bg-gradient-to-r after:from-blue-700 after:to-black/10 after:content-['']"
    :style="bannerStyle"
  >
    <div
      class="container-wrap relative z-10 flex h-mobile-banner py-2 tablet:h-banner"
    >
      <div class="flex w-full flex-col justify-center text-white">
        <div>
          <h1 class="text-h1 banner-title mb-2" v-html="decode(t('title'))" />
          <p
            class="banner-description is-mobile-hidden mb-3"
            v-html="decode(t('description'))"
          />
        </div>
        <TheButton
          class="w-full tablet:w-[180px]"
          :title="t('item-button')"
          :to="`/${$i18n.locale}/marketplace/help/sales-support?IssueType=1`"
        >
          <span class="text-sm">{{ t('item-button') }}</span>
        </TheButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { decode } from 'entities';

  const { t } = useI18n({ useScope: 'local' });
  const { blobDomain } = useWebsite();
  const { provideResponsiveImgName } = useImagePath();

  const bannerStyle = computed((): string => {
    return `background-image: url(${blobDomain.value}/wise-paas-marketplace/topics/doe/${provideResponsiveImgName('banner')})`;
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "en-jp": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "en-tw": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "en-kr": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "en-americas": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "en-asia-pacific": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "en-emea": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "ja-jp": {
    "title": "AIを活用したデジタルO&Mとエネルギー管理",
    "description": "Advantech WISEは、現場・設備データを統合し、遠隔運用や複数拠点の可視化、AIによる最適化を実現。エネルギー・ユーティリティ企業の安定運用と効率向上を支援します。",
    "item-button": "お問い合わせ"
  },
  "zh-cn": {
    "title": "AI-Powered Digital O&M for Energy Operations",
    "description": "Advantech WISE connects site data for <strong>remote operations</strong>, <strong>multi-site visibility</strong>, and <strong>AI-driven optimization</strong>—helping energy and utilities operate more reliably and efficiently.",
    "item-button": "Contact Us"
  },
  "zh-tw": {
    "title": "AI 驅動數位維運與能源管理",
    "description": "Advantech WISE 整合現場數據，實現遠端監控、跨據點統一可視化及 AI 智慧優化，協助能源與公用事業提升營運效率與穩定性",
    "item-button": "聯絡我們"
  }
}
</i18n>
